module.exports = __webpack_public_path__ + "static/media/relative_pronoun_img.b7132ed2.JPG";